"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FlagLined = function FlagLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19 4.438a.5.5 0 00-.787-.345A5.964 5.964 0 0115 5a4.915 4.915 0 01-2.59-.9A6.434 6.434 0 009 3a8.2 8.2 0 00-3.868 1.2l-.14-.791a.5.5 0 10-.984.174l3 17A.5.5 0 007.5 21a.437.437 0 00.088-.008.5.5 0 00.405-.579l-1.188-6.729A4.776 4.776 0 0110 12a4.981 4.981 0 012.781.938A5.768 5.768 0 0016 14a6.263 6.263 0 003.816-1.113.5.5 0 00.18-.449zM16 13a4.877 4.877 0 01-2.7-.92A5.955 5.955 0 0010 11a5.3 5.3 0 00-3.407 1.487L5.318 5.259A7.658 7.658 0 019 4a5.451 5.451 0 012.911.971A5.858 5.858 0 0015 6a7.224 7.224 0 003.1-.7l.87 6.957A5.78 5.78 0 0116 13z",
    fill: "currentColor"
  })));
};

var _default = FlagLined;
exports["default"] = _default;